export const mallRoutes = [
    {
        path: '/mall/raffle',
        name: 'mallraffleList',
        component: () => 
        /* webpackChunkName: "mallraffle" */ import('@/views/mall/raffle/list.vue'),
        meta: {
            title: '抽奖活动列表'
        }
    },
    {
        path: '/mall/raffle/:id',
        name: 'mallraffleDetail',
        component: () => 
        /* webpackChunkName: "mallraffle" */ import('@/views/mall/raffle/detail.vue'),
        meta: {
            title: '抽奖详情'
        }
    },
    {
        path: '/mall/raffle/record',
        name: 'mallraffleRecord',
        component: () => 
        /* webpackChunkName: "mallraffle" */ import('@/views/mall/raffle/record.vue'),
        meta: {
            title: '获奖记录'
        }
    },
    {
        path: '/mall/good/list',
        name: 'mallGoodList',
        component: () => import('@/views/mall/goods/list.vue'),
        meta: {
            title: '商品列表'
        }
    }
];
